import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import type { UpsertFavoriteListModalProps } from './type'

import { UpsertFavoriteListForm } from '@/components/features/favorite'
import { Dialog } from '@/components/ui'
import { useMyStore } from '@/hooks/features/store'

export const UpsertFavoriteListModal = ({
  isOpen,
  favorite,
  onClickConfirm,
  onClickCancel,
}: UpsertFavoriteListModalProps) => {
  const { t } = useTranslation()
  const myStore = useMyStore({})

  const title = useMemo(
    () =>
      favorite === undefined
        ? t('favorite.list.create')
        : t('favorite.list.edit'),
    [favorite, t]
  )

  const isDepositStore = useMemo(() => {
    if (!myStore.data?.isDepositStore) {
      return false
    }
    // create
    if (!favorite) {
      return true
    }
    // update
    return favorite.isEditableByMe
  }, [myStore, favorite])

  return (
    <Dialog title={title} isOpen={isOpen}>
      <UpsertFavoriteListForm
        favorite={favorite}
        isDepositStore={isDepositStore}
        onClickConfirm={onClickConfirm}
        onClickCancel={onClickCancel}
      />
    </Dialog>
  )
}
